<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Edit Tag</modal-header>
        </div>
        <div>
          <form-group>
            <field name="Name" :value="name" v-model="name" />
          </form-group>
        </div>
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'
import {modalMixin} from '@/mixins/modalMixin'
import {tagMixin} from '@/mixins/tagMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_edit_tag',
  mixins: [modalMixin, tagMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field
  },
  props: {
    show: Boolean,
    confirmId: String,
    field: String
  },
  data: () => ({
    name: ''
  }),
  computed: {},
  methods: {
    confirm () {
      this.startLoading()
      const data = {
        id: this.confirmId,
        name: this.name
      }
      this.updateTag(data).then(() => {
        this.addNotification('success', 'Tag updated.')
        this.getAllTagsCreative(this.$route.params.id).then(() => {
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  },
  watch: {
    field: function () {
      this.name = this.field
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/tags/modal-edit-tag.vue